/**
 * Gets the screen width
 */
function getScreenWidth() {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  );
}

// function initAccountControls() {
//   const loginBtn
// }
const wpAdminBar = document.querySelector("#wpadminbar");
const header = document.querySelector(".site-header");
const rootElm = document.querySelector(":root");
const MENU_TOGGLE = document.querySelector(".menu-toggle");

function resizeHeader() {
  if (window.scrollY >= 30) {
    rootElm.style.setProperty("--header-height", 7.5 + "rem");
    header.classList.add("secondary");
  } else {
    rootElm.style.setProperty("--header-height", 14 + "rem");
    header.classList.remove("secondary");
  }
}

function subMenuDropdownAnimate() {
  const menuItemHasChildren = document.querySelectorAll(
    ".menu-item-has-children"
  );
  menuItemHasChildren.forEach((item) => {
    item.addEventListener("mouseover", function () {
      item.querySelector(".sub-menu").classList.add("show");
    });
    item.addEventListener("mouseleave", function () {
      item.querySelector(".sub-menu").classList.remove("show");
    });
  });
}

function toggleHeaderMobile() {
  MENU_TOGGLE.classList.toggle("toggled");
  header.classList.toggle("show");
}

function initHeader() {
  if (wpAdminBar) {
    const adminBarHeight = wpAdminBar.offsetHeight;
    document
      .querySelector("header")
      .style.setProperty("--header-top", adminBarHeight + "px");
  }

  if (getScreenWidth() >= 1024) {
    resizeHeader();
    subMenuDropdownAnimate();
    window.addEventListener("scroll", resizeHeader, true);
    MENU_TOGGLE.removeEventListener("click", toggleHeaderMobile, true);
  } else {
    window.removeEventListener("scroll", resizeHeader, true);
    rootElm.style.setProperty("--header-height", 7.5 + "rem");
    if (header.classList.contains("secondary")) {
      header.classList.remove("secondary");
    }

    MENU_TOGGLE.addEventListener("click", toggleHeaderMobile, true);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initHeader();
  window.onresize = initHeader;
});
